import * as t from 'io-ts';

import {InboxesParameters} from '../../panels/inboxes/parameters/inboxesParameters';
import {
  CellsListState,
  makeCellsListTypePredicateForParameters,
  RCellsListState,
} from './cellsList/cellsListState';

/*
 * Runtime type.
 */

export const RCellsListsState = t.readonlyArray(RCellsListState);

/*
 * Type.
 */

// TODO: Figure out why t.TypeOf<RCellsListsState> does not agree with this.
export type CellsListsState = ReadonlyArray<CellsListState>;

/*
 * Helpers.
 */

export function filterCellsListTypeForParameters<T extends InboxesParameters>(
  lists: CellsListsState,
  parameters: T,
) {
  const cellsListTypePredicate = makeCellsListTypePredicateForParameters(parameters);
  return lists.filter(cellsListTypePredicate);
}
